























import {Component, Prop, Vue} from 'vue-property-decorator';
import {NodeSummaryWidgetIntervalType} from './enums';
import {nodeSummaryWidgetIntervalTypes} from './configurate';

@Component({})
export default class OrNodeSummaryWidgetBindForm extends Vue {
  valid = true;

  @Prop({required: false})
  initIntervalType!: NodeSummaryWidgetIntervalType;

  intervalType: NodeSummaryWidgetIntervalType =
    this.initIntervalType || NodeSummaryWidgetIntervalType.Day;

  get intervalTypes() {
    return nodeSummaryWidgetIntervalTypes;
  }
}
